<div class="border-b">
  <div class="navigation flex items-center container">
    @for (item of items$ | async; track item) {
      <vex-navigation-item
      [item]="item"></vex-navigation-item>
    }
  </div>
</div>
